import {
  DoubleSide,
  MeshStandardMaterial,
  type MeshStandardMaterialParameters,
} from "three";

// Sheet metal ("Blech"): slightly bluish and more matte than the smoother, more
// reflective aluminium profiles, to increase visual contrast between part types.
// Single source of truth for both the raw material and the JSX component.
const SHEET_METAL_MATERIAL_PARAMS: MeshStandardMaterialParameters = {
  color: "#eaf2f5",
  metalness: 0.95,
  roughness: 0.25,
  envMapIntensity: 1.15,
  side: DoubleSide,
};

export const getRawSheetMetalMaterial = () =>
  new MeshStandardMaterial(SHEET_METAL_MATERIAL_PARAMS);

export const SheetMetalMaterial = () => (
  <meshStandardMaterial {...SHEET_METAL_MATERIAL_PARAMS} />
);
